import { isEditor3Host } from './get-editor-host';

/**
 * Gets design props for fixer components based on editor host
 * @param editorHost - The current editor host
 * @returns FixerDesignProps configured for the editor host
 */
export const getFixerDesignProps = editorHost => {
  const isEditor3 = isEditor3Host(editorHost);
  if (isEditor3) {
    return {
      formGap: 'SP3',
      ruleFooter: {
        marginTop: 'SP2'
      }
    };
  } else {
    return {
      formGap: 'SP1',
      ruleFooter: {
        marginTop: '0px'
      },
      ruleLayout: {
        gap: 'SP2'
      }
    };
  }
};

/**
 * Gets footer button types based on editor host
 * @param editorHost - The current editor host
 * @returns Button types configuration for FooterLabels
 */
export const getFooterButtonTypes = editorHost => {
  const isEditor3 = isEditor3Host(editorHost);
  return {
    dismiss: isEditor3 ? 'button' : 'textButton'
  };
};
//# sourceMappingURL=get-fixer-design-props.js.map